// extracted by mini-css-extract-plugin
module.exports = {"side_share_box":"side_share_box-2md7SeeX"};